import { useEffect, useState } from "react";
import { Coins, Loader2, Check } from "lucide-react";
import { api, formatApiError } from "../../lib/api";
import { fcfa } from "../../lib/format";
import { useAuth } from "../../context/AuthContext";
import { toast } from "sonner";

export function AdminVendeurCommissions() {
  const { user } = useAuth();
  const [rows, setRows] = useState(null);
  const [paying, setPaying] = useState(null);

  const load = () => api.get("/admin/vendeur-commissions").then(({ data }) => setRows(data)).catch(() => setRows(false));
  useEffect(() => { load(); }, []);

  const pay = async (sellerId) => {
    if (!window.confirm("Marquer toutes les commissions dues de ce vendeur comme payées ?")) return;
    setPaying(sellerId);
    try {
      const { data } = await api.post(`/admin/vendeur-commissions/${sellerId}/pay`);
      toast.success(`${data.marked_paid} commission(s) marquée(s) payée(s)`);
      load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setPaying(null); }
  };

  if (rows === null) return <div className="bg-white border border-brand-line rounded-2xl p-6 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-brand" /></div>;
  if (rows === false) return null;

  return (
    <div data-testid="admin-vendeur-commissions" className="bg-white border border-brand-line rounded-2xl p-5 sm:p-6">
      <div className="flex items-center gap-2 mb-4">
        <span className="w-9 h-9 rounded-xl bg-amber-100 text-amber-700 flex items-center justify-center"><Coins className="w-5 h-5" /></span>
        <h2 className="font-heading font-bold text-brand-ink">Commissions vendeurs</h2>
      </div>
      {rows.length === 0 ? <p className="text-sm text-brand-muted">Aucun vendeur.</p> : (
        <div className="space-y-2">
          {rows.map((r) => (
            <div key={r.seller_id} data-testid={`commission-row-${r.seller_id}`} className="flex items-center justify-between border border-brand-line rounded-xl px-4 py-3">
              <div>
                <p className="font-semibold text-brand-ink text-sm">{r.name}</p>
                <p className="text-xs text-brand-muted">Payé : {fcfa(r.commission_paid)}</p>
              </div>
              <div className="flex items-center gap-3">
                <div className="text-right">
                  <p className="text-[11px] text-brand-muted">À payer</p>
                  <p className="font-heading font-black text-amber-700">{fcfa(r.commission_due)}</p>
                </div>
                {user?.role === "patron" && (
                  <button onClick={() => pay(r.seller_id)} disabled={r.commission_due <= 0 || paying === r.seller_id}
                    data-testid={`pay-commission-${r.seller_id}`}
                    className="bg-brand text-white hover:bg-brand-hover rounded-full px-4 py-2 text-sm font-semibold flex items-center gap-1.5 disabled:opacity-40 disabled:cursor-not-allowed">
                    {paying === r.seller_id ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />} Payer
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
